App.controller('FlotChartControllerStat', ['$scope', '$window','$http', '$filter', '$timeout',
                                       function($scope, $window, $http, $filter,$timeout) {
  'use strict';

  /**
   * Global object to load data for charts using ajax
   * Request the chart data from the server via post
   * Expects a response in JSON format to init the plugin
   * Usage
   *   chart = new floatChart(domSelector || domElement, 'server/chart-data.php')
   *   ...
   *   chart.requestData(options);
   *
   * @param  Chart element placeholder or selector
   * @param  Url to get the data via post. Response in JSON format
   */
  $window.FlotChartStat = function (element, url) {
    // Properties
    this.element = $(element);
    this.url = url;

    // Public method
    this.requestData = function (option, method, callback) {
      var self = this;

      // support params (option), (option, method, callback) or (option, callback)
      callback = (method && $.isFunction(method)) ? method : callback;
      method = (method && typeof method == 'string') ? method : 'GET';

      self.option = option; // save options

      $http({
          url:      self.url,
          cache:    false,
          method:   method
      }).then(function (data) {

          $.plot( self.element, data, option );

          if(callback) callback();

      }).catch(function(){
        $.error('Bad chart request.');
      });

      return this; // chain-ability

    };

    this.setData = function (option, data, callback) {
        var self = this;

        self.option = option; // save options
        var bands = ['total','context','full','fuzzy','nomatch'];
        var plot = $.plot( self.element, data, option );
        var o=plot.getCanvas();
        if(option.centralNumber){

            for(var n in bands){
                var display = bands[n]=='total' ? 'inline-block' : 'none';
                self.element.append('<div id="'
                    +self.element[0].id
                    +'_' + bands[n]
                    +'-centralNumber" class="number-in-chart '+bands[n]+'" style="display:'+display+';width:'
                    +o.clientWidth
                    +'px;height:30'
                    //+o.height
                    +'px;"><span id="number-in-chart-tooltip-container" style="position:relative;">'
                    +option.centralNumber[bands[n]]+'<span id="number-in-chart-tooltip">'+$filter('translate')('labels.TOTALSAVING')+'</span></span></div>');
            }
            self.element.resize(function(e){
            	//var myName='#'+self.element[0].id+"-centralNumber";
            	$('.number-in-chart').css('width',self.element[0].clientWidth);
            });
        }

        self.element.bind("plotclick", function(event, pos, obj) {

			if (!obj) {
				return;
			}

            var band = bands[obj.seriesIndex+1];
            angular.element('#MainView').scope().setband(band);
            angular.element('#MainView').scope().$apply();
		});

        if(callback) callback();

        return this; // chain-ability

      };

    // Listen to refresh events
    this.listen = function() {
      var self = this,
          chartPanel = this.element.parents('.panel').eq(0);

      // attach custom event
      chartPanel.on('panel-refresh', function(event, panel) {
        // request data and remove spinner when done
        self.requestData(self.option, function(){
          panel.removeSpinner();
        });

      });

      return this; // chain-ability
    };

  };

  $scope.init = function(){

	    	if($scope.model && $scope.model.stat){
	    		$scope.initialized = true;

	         // Donut
	            $timeout((function () {
	                var Selector = '#chart_'+($scope.model.stat ? $scope.model.stat : '');
	                $(Selector).each(function() {
	                    //var source = $(this).data('source') || $.error('Donut: No source defined.');
	                    var chart = new FlotChartStat(this),
	                        option = {
	                            series: {
	                                pie: {
	                                    show: true,
	                                    innerRadius: 0.5 // This makes the donut shape
	                                }
	                            },
                				grid: {
                					hoverable: true,
                					clickable: true
                				},
                                centralNumber: {
                                    total: '-' + $filter('display')($scope.model.total.discount, {type:'decimal',decimals:0,def:0})
                                        + '%',
                                    context: '-' + $filter('display')($scope.model.context.discount, {type:'decimal',decimals:0,def:0})
                                        + '%',
                                    full: '-' + $filter('display')($scope.model.full.discount, {type:'decimal',decimals:0,def:0})
                                        + '%',
                                    fuzzy: '-' + $filter('display')($scope.model.fuzzy.discount, {type:'decimal',decimals:0,def:0})
                                        + '%',
                                    nomatch: '-' + $filter('display')($scope.model.nomatch.discount, {type:'decimal',decimals:0,def:0})
                                        + '%'
                                    }
	                        };
	                    // Send Request
	                    chart.setData(option, [ { "color" : "#32CD32",
	                        "data" : $scope.model.context.value,
	                        "label" : $filter('translate')('custom.'+$scope.client+'.labels.CONTEXTMATCH', {__emptyIfNotFound__:true}) || $filter('translate')('labels.CONTEXTMATCH')
	                      },
	                      { "color" : "#2E8B57",
	                        "data" : $scope.model.full.value,
	                        "label" : $filter('translate')('custom.'+$scope.client+'.labels.FULLMATCH', {__emptyIfNotFound__:true}) || $filter('translate')('labels.FULLMATCH')
	                      },
	                      { "color" : "#FFD700",
	                        "data" : $scope.model.fuzzy.value,
	                        "label" : $filter('translate')('custom.'+$scope.client+'.labels.FUZZYMATCH', {__emptyIfNotFound__:true}) || $filter('translate')('labels.FUZZYMATCH')
	                      },
	                      { "color" : "#B22222",
	                        "data" : $scope.model.nomatch.value,
	                        "label" : $filter('translate')('custom.'+$scope.client+'.labels.NOMATCH', {__emptyIfNotFound__:true}) || $filter('translate')('labels.NOMATCH')
	                      }
	                    ]);
	                });
	            }),500);

	    	} else {
	            if(!$scope.watchActivated){
	                $scope.watchActivated = true;
	                $scope.$watch('model.stat', function(){
	                    //if(!$scope.initialized){
	                        $scope.init();
	                    //}
	                });
	            }
	        }
	    }

  $scope.init();

  $scope.clickOnChart = function(e){
      var t = ''+e.target.outerHTML;
      var band = '';
      if(t.indexOf('Context match')>=0 || t.indexOf('#32CD32')>=0){
          band='context';
      } else if(t.indexOf('Full match')>=0 || t.indexOf('#2E8B57')>=0){
          band='full';
      } else if(t.indexOf('Fuzzy match')>=0 || t.indexOf('#FFD700')>=0){
          band='fuzzy';
      } else if(t.indexOf('No match')>=0 || t.indexOf('#B22222')>=0){
          band='nomatch';
      }
      if(band){
          angular.element('#MainView').scope().setband(band);
          angular.element('#MainView').scope().$apply();
      }
  }

}]);
